export const checkAccess = (rolesAllowed, user) => {
  return !!(user && user.userRoles.some((r) => rolesAllowed.indexOf(r) >= 0));
};
